import { createContext, ProviderProps, RefObject, useEffect, useRef, useState } from 'react';

import { GlobalStyle } from '@/common/components/Drawer/Drawer.styled';

interface DrawerContextProps {
  scrollBarWidth: number;
  handleBackdropClose?: () => void;
  handleBackdropOpen?: () => void;
  drawerPortal?: RefObject<HTMLDivElement>;
}
export const DrawerContext = createContext<DrawerContextProps>({
  scrollBarWidth: 0,
});

const getScrollbarWidth = (): number => {
  return window.innerWidth - document.documentElement.clientWidth;
};

export const DrawerContextProvider = ({ children, value }: ProviderProps<DrawerContextProps>) => {
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const [scrollBarWidth, setScrollBarWidth] = useState<number>(0);
  const ref = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    setScrollBarWidth(getScrollbarWidth());
  }, []);

  return (
    <DrawerContext.Provider
      value={{
        ...value,
        scrollBarWidth,
        handleBackdropClose: () => setIsOpen(false),
        handleBackdropOpen: () => setIsOpen(true),
        drawerPortal: ref,
      }}
    >
      <GlobalStyle isOpen={isOpen} scrollBarWidth={scrollBarWidth} />
      {children}
      <div ref={ref}></div>
    </DrawerContext.Provider>
  );
};
